import styled from 'styled-components'

export const SessionName = styled.div`
  font-weight: var(--font-bold);
  font-size: 14px;
  line-height: 1.3;
  padding-bottom: 5px;
`

export const OptionSummaryWrapper = styled.span`
  display: flex;
  flex-direction: column;
  gap: 3px;
`

export const OptionSummary = styled.span`
  font-weight: var(--font-medium);
  font-size: 14px;
  line-height: 1.3;
  display: block;
`
